<template>
	<div class="pb-5">
		<b-button class="filter" variant="light" block href="#" v-b-toggle.accordion-filter>
			<span><b-icon-funnel-fill></b-icon-funnel-fill> Filter</span>
			<span class="menu-arrow">
				<b-icon-chevron-right class="float-right chevron-right"></b-icon-chevron-right><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
			</span>
		</b-button>
		<b-collapse id="accordion-filter" accordion="accordion-filter" role="tabpanel" class="menu-accordion">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="filter-name" size="sm" :model.sync="filter.name" />
					<!-- enable this if you need combo box, delete if you didn't need it <app-input-combobox-autocomplete :options="approvalTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Type" id="filter-" size="sm" :model.sync="filter.approvalTypeId" @input="getApprovalTypes" @focus="getApprovalTypes" /> -->
					<app-input-textarea id="fieldset-approval-type" label-cols-sm="4" label-cols-lg="3" label="Approval Type" label-for="filter-approval-type" size="sm" :model.sync="filter.approvalTypeName" :modelExact.sync="filter.exactType.approvalTypeName" />
					<app-input-textarea id="fieldset-description" label-cols-sm="4" label-cols-lg="3" label="Description" label-for="filter-description" size="sm" :model.sync="filter.descriptionMultiple" />
					<!-- enable this if you need combo box, delete if you didn't need it <app-input-combobox-autocomplete :options="appliedTos" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Applied To" id="filter-" size="sm" :model.sync="filter.appliedToId" @input="getAppliedTos" @focus="getAppliedTos" /> -->
					<app-input-textarea id="fieldset-applied-to" label-cols-sm="4" label-cols-lg="3" label="Applied To" label-for="filter-applied-to" size="sm" :model.sync="filter.appliedToName" :modelExact.sync="filter.exactType.appliedToName" />
					<b-button variant="danger" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" size="sm" class="float-right mr-1" @click="getApprovalConfigurations"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
		</b-collapse>
		<b-row class="mt-3">
			<b-col>
				<b-button variant="warning" v-if="(userRole != null ? userRole.allowUpdate : false)" class="float-right ml-2" @click="showPopupUploadData" size="sm"><b-icon-upload class="mr-1"></b-icon-upload> Upload</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDownload : false)"
					:show="isDownloadDataBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</b-overlay>
				<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right" :href="`files/ApprovalConfiguration/ApprovalConfiguration.xlsx`" size="sm"><b-icon-wallet-fill class="mr-1"></b-icon-wallet-fill> Download Template</b-button>
			</b-col>
		 </b-row>
		<b-card class="mt-3 mb-3">
		<b-row class="mb-3">
			<b-col>
				<b-overlay
					v-if="(userRole != null ? userRole.allowCreate : false)"
					:show="isCreateBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" @click="createData" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				</b-overlay>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="head-light"  :no-local-sorting="true" :items="approvalConfigurations" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :tbody-tr-class="rowClass" small responsive>
			<template v-slot:head(actions)>
				<b-button-group class="float-right"  size="sm">
					<b-button @click="isShowFilter = !isShowFilter" size="sm"><b-icon-funnel-fill /></b-button>
					<b-button><b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right" v-model="selectAll"></b-form-checkbox></b-button>
				</b-button-group>
			</template>
			<template #top-row v-if="isShowFilter">
				<b-th></b-th>
				<b-th stacked-heading="Name">
					<b-form-input id="input-name-table" @input="getApprovalConfigurationsWithoutLoading" v-model="filter.name" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approval Type">
					<v-select append-to-body label="name" :options="approvalTypes" :value="filter.approvalTypeId" :reduce="item => item.id" v-model="filter.approvalTypeId" :filterable="true" @input="getApprovalConfigurationsWithoutLoading" @search="getApprovalTypes"  @focus="getApprovalTypes"></v-select>
				</b-th>
				<b-th stacked-heading="Description">
					<b-form-input id="input-description-table" @input="getApprovalConfigurationsWithoutLoading" v-model="filter.description" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Applied To">
					<v-select append-to-body label="name" :options="appliedTos" :value="filter.appliedToId" :reduce="item => item.id" v-model="filter.appliedToId" :filterable="true" @input="getApprovalConfigurationsWithoutLoading" @search="getAppliedTos"  @focus="getAppliedTos"></v-select>
				</b-th>
				<b-th stacked-heading="Select All">
					<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>
			<template v-slot:cell(approvalType)="row">
				{{ row.item.approvalType != null ? row.item.approvalType.name : "" }}
			</template>
			<template v-slot:cell(appliedTo)="row">
				{{ row.item.appliedTo != null ? row.item.appliedTo.name : "" }}
			</template>
			<template v-slot:cell(actions)="row" >
				<div class="div-actions float-right">
				<b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" @click="editData(row.index, row.item.id)" variant ="success"  class="mr-2 btn-xs">
					<b-icon-pencil></b-icon-pencil>
				</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDelete : false)"
					:show="busy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<click-confirm>
					<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
						<b-icon-trash></b-icon-trash>
					</b-button>
					</click-confirm>
				</b-overlay>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowRead : false)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" @click="showTableDetail(row.item.id)" >
					<b-icon-eye-fill></b-icon-eye-fill>
				</b-button>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowPrint : false)" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
					<b-icon-printer-fill></b-icon-printer-fill>
				</b-button>
				<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox>
				</div>
			</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" md="6" lg="6">
				<b-overlay
					v-if="(userRole != null ? userRole.allowCreate : false)"
					:show="isCreateBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" @click="createData" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				</b-overlay>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col cols="12" md="6" lg="6">
			<b-pagination
				class="float-md-right btn-paging"
				v-model="currentPage"
				:total-rows="(approvalConfigurationsPaging != null ? approvalConfigurationsPaging.dataCount : 0)"
				:per-page="(approvalConfigurationsPaging != null ? approvalConfigurationsPaging.pageSize : 0)"
				aria-controls="my-table"
			></b-pagination>
			</b-col>
		</b-row>
		</b-card>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
	<b-card class="mb-3" header-bg-variant="transparent" v-if="isShowTableApprovalConfigurationDetail">
		<template #header>
			<b-row>
				<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Approval Configuration Detail</h5></b-col>
				<b-col>
					<span class="float-right">
						<button class="close" no-variant @click="isShowTableApprovalConfigurationDetail = false">×</button>
					</span>
				</b-col>
			</b-row>
		</template>
		<b-row class="mb-2">
			<b-col>
				<span class="float-right">
					<b-form-select v-model="approvalConfigurationDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<div class="table-corner table-row-selected">
			<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approvalConfigurationDetails" :fields="fieldsApprovalConfigurationDetail" :busy="isDataLoading" :sort-by.sync="sortByApprovalConfigurationDetail" :sort-desc.sync="sortDescApprovalConfigurationDetail" small responsive>
			<!--APP_TABLE_FILTER-->
			<template v-slot:head(actions)>
				<b-button @click="isShowApprovalConfigurationDetailFilter = !isShowApprovalConfigurationDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>
			<template #top-row v-if="isShowApprovalConfigurationDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Approver Type">
					<v-select append-to-body label="name" :options="approverTypes" :value="filterApprovalConfigurationDetail.approverTypeId" :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approverTypeId" @search="getApproverTypes" :filterable="true"  @focus="getApproverTypes"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures" :value="filterApprovalConfigurationDetail.approvalStructureId" :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approvalStructureId" @search="getApprovalStructures" :filterable="true"  @focus="getApprovalStructures"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Level">
					<b-form-input id="input-approver-level-table" v-model="filterApprovalConfigurationDetail.approverLevel" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approver User Name">
					<v-select append-to-body label="firstName" :options="userInfos" :value="filterApprovalConfigurationDetail.approverUserNameUserName" :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approverUserNameUserName" @search="getUserInfos" :filterable="true"  @focus="getUserInfos"></v-select>
				</b-th>
				<b-th stacked-heading="Stored Procedure Name">
					<b-form-input id="input-stored-procedure-name-table" v-model="filterApprovalConfigurationDetail.storedProcedureName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approval Type">
					<b-form-input id="input-approval-type-table" v-model="filterApprovalConfigurationDetail.approvalType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Configuration Content">
					<b-form-input id="input-configuration-content-table" v-model="filterApprovalConfigurationDetail.configurationContent" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Send Notification">
					<b-form-checkbox id="input-is-send-notification-table" class="float-right" v-model="filterApprovalConfigurationDetail.isSendNotification"></b-form-checkbox>
				</b-th>
				<b-th></b-th>
			</template>
			<!--END_APP_TABLE_FILTER-->
			<!--APP_TABLE_DATA-->
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( approvalConfigurationDetailPageSize * (currentApprovalConfigurationDetailPage - 1))) }}
			</template>
			<template v-slot:cell(approvalConfiguration)="row">
				{{ row.item.approvalConfiguration != null ? row.item.approvalConfiguration.name : "" }}
			</template>
			<template v-slot:cell(approverType)="row">
				{{ row.item.approverType != null ? row.item.approverType.name : "" }}
			</template>
			<template v-slot:cell(approvalStructure)="row">
				{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
			</template>
			<template v-slot:cell(approverUserName)="row">
				{{ row.item.approverUserName != null ? row.item.approverUserName.firstName : "" }}
			</template>
			<!--END_APP_TABLE_DATA-->
			</b-table>
			</div>
		</b-col>
		<b-col cols="12">
			<!--APP_TABLE_PAGINATION-->
			<b-pagination
			class="float-right btn-paging"
			v-model="currentApprovalConfigurationDetailPage"
			:total-rows="totalApprovalConfigurationDetailRow"
			:per-page="approvalConfigurationDetailPageSize"
			aria-controls="my-table"
			></b-pagination>
			<!--END_APP_TABLE_PAGINATION-->
		</b-col>
		</b-row>
	</b-card>
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationList from '@/models/ApprovalConfiguration/ApprovalConfigurationList';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppliedToFilter from '@/filters/AppliedTo/AppliedToFilter';
import AppliedTo from '@/models/AppliedTo/AppliedTo';
import ApprovalConfigurationDetail from '@/models/ApprovalConfiguration/ApprovalConfigurationDetail';
import ApprovalConfigurationDetailFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationDetailFilter';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {ApprovalConfiguration, ApprovalConfigurationList, ApprovalConfigurationFilter, AppInputTextbox,AppInputComboboxAutocomplete,AppInputTextarea,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			isShowTableDetail: false,
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : { "class" : "th-number"}}, 
				{"name": {}, "class" : "th-name", "label" : "Name", key: 'name', sortable: true}, 
				{"approvalType": {}, "class" : "th-approval-type", "label" : "Approval Type", key: 'approvalType', sortable: true}, 
				{"description": {}, "class" : "th-description", "label" : "Description", key: 'description', sortable: true}, 
				{"appliedTo": {}, "class" : "th-applied-to", "label" : "Applied To", key: 'appliedTo', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			modelId: "",
			approvalConfigurations: [],
			approvalConfigurationsPaging: {},
			approvalTypes : [],
			appliedTos : [],
			fieldsApprovalConfigurationDetail: [
				{"no" : {  "class" : "th-number" }},
				{"approverType": {},  "class" : "th-approver-type", "label" : "Approver Type", key: 'approverType', sortable: true}, 
				{"approvalStructure": {},  "class" : "th-approval-structure", "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"approverLevel": {},  "class" : "th-approver-level", "label" : "Approver Level", key: 'approverLevel', sortable: true}, 
				{"approverUserName": {},  "class" : "th-approver-user-name", "label" : "Approver User Name", key: 'approverUserName', sortable: true}, 
				{"storedProcedureName": {},  "class" : "th-stored-procedure-name", "label" : "Stored Procedure Name", key: 'storedProcedureName', sortable: true}, 
				{"approvalType": {},  "class" : "th-approval-type", "label" : "Approval Type", key: 'approvalType', sortable: true}, 
				{"configurationContent": {},  "class" : "th-configuration-content", "label" : "Configuration Content", key: 'configurationContent', sortable: true}, 
				{"isSendNotification": {},  "class" : "th-is-send-notification", "label" : "Is Send Notification", key: 'isSendNotification', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			filterApprovalConfigurationDetail : null,
			currentApprovalConfigurationDetailPage : 1,
			approvalConfigurationDetailPageSize: 10,
			sortByApprovalConfigurationDetail: '',
			sortDescApprovalConfigurationDetail: '',
			sortingByApprovalConfigurationDetail: [],
			approvalConfigurationDetails : [],
			approvalConfigurationDetailId : '',
			totalApprovalConfigurationDetailRow : 0,
			isShowApprovalConfigurationDetailFilter: false,
			isShowTableApprovalConfigurationDetail: false,
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
		}
	},
	methods : {
		getApprovalConfigurations : async function() {
			this.hideAllTableDetail();
			this.modelId = '';
			this.resetChildFilter();
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalConfiguration.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalConfigurations = result.data
					this.approvalConfigurationsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getApprovalConfigurationsWithoutLoading : async function() {
			this.hideAllTableDetail();
			this.modelId = '';
			this.resetChildFilter();
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalConfiguration.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalConfigurations = result.data
					this.approvalConfigurationsPaging = result
				}
			})
			.catch(error => {});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
			})
			.catch(error => {});
		},
		getAppliedTos : async function(input) {
			let filter = new AppliedToFilter();
			if (input != undefined) {
				filter.name = input;
			}
			AppliedTo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.appliedTos = result.data
				}
			})
			.catch(error => {});
		},
		/*APP_DETAIL_GETAPPROVERTYPE*/
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETAPPROVERTYPE*/
		/*APP_DETAIL_GETAPPROVALSTRUCTURE*/
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETAPPROVALSTRUCTURE*/
		/*APP_DETAIL_GETUSERINFO*/
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETUSERINFO*/
		/*APP_DETAIL_GETApprovalConfigurationDetail*/
		getApprovalConfigurationDetails : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfigurationDetail);
			if (this.modelId == null || this.modelId == undefined || this.modelId == '') return;
			if (!this.isShowTableApprovalConfigurationDetail) return;
			filter.approvalConfigurationId = this.modelId;
			this.sortingByApprovalConfigurationDetail = Array();
			if (this.sortByApprovalConfigurationDetail != null) {
				this.sortingByApprovalConfigurationDetail[this.sortByApprovalConfigurationDetail] = this.sortDescApprovalConfigurationDetail;
			}
			let currentPage = (this.currentApprovalConfigurationDetailPage - 1);
			ApprovalConfigurationDetail.getList(this, filter, this.sortingByApprovalConfigurationDetail, currentPage , this.approvalConfigurationDetailPageSize).then(result => {
				this.approvalConfigurationDetails = result.data;
				this.totalApprovalConfigurationDetailRow = result.dataCount;
			}).catch(error => {});
		},
		/*END_APP_DETAIL_GETApprovalConfigurationDetail*/
		resetFilter() {
			this.filter = new ApprovalConfigurationFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getApprovalConfigurations();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ApprovalConfiguration.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ApprovalConfiguration.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			ApprovalConfiguration.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		createData() {
			this.isCreateBusy = true;
			ApprovalConfiguration.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'approvalconfigurationedit', params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			ApprovalConfiguration.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'approvalconfigurationedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},
		deleteData(id) {
			ApprovalConfiguration.deleteData(this, id).then(result => {
				if (result)
				{
					this.getApprovalConfigurations();
				}
			})
		},
		showTableDetail(id) {
			this.showAllTableDetail();
			this.modelId = id;
			this.getApprovalConfigurationDetails()
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return;
			if (item.id === this.modelId) {
			if (this.isShowTableApprovalConfigurationDetail) {
				return 'table-row-selected';
			}
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
		resetChildFilter() {
			this.filterApprovalConfigurationDetail = new ApprovalConfigurationDetailFilter();
		},
		showAllTableDetail() {
			this.isShowTableApprovalConfigurationDetail = true;
		},
		hideAllTableDetail() {
			this.isShowTableApprovalConfigurationDetail = false;
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ApprovalConfigurationFilter();
		this.filterApprovalConfigurationDetail = new ApprovalConfigurationDetailFilter();
		this.getApproverTypes();
		this.getApprovalStructures();
		this.getUserInfos();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Approval Configuration"
		];
		this.getApprovalConfigurations();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		sortDesc: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		currentPage: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ApprovalConfiguration.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "approvalconfiguration") {
					this.getApprovalConfigurationsWithoutLoading();
				}
			}
		},
		modelId: {
			handler: function() {
				this.resetChildFilter();
			}
		},
		/*APP_DETAIL_WATCH_APPROVALCONFIGURATIONDETAIL*/
		sortByApprovalConfigurationDetail : {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		sortDescApprovalConfigurationDetail: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		currentApprovalConfigurationDetailPage: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		approvalConfigurationDetailPageSize : {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		computedFilterApprovalConfigurationDetail: {
			handler: function(newValue, oldValue) {
				if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
					this.getApprovalConfigurationDetails();
				}
			},
			deep: true,
		},
		/*END_APP_DETAIL_WATCH_APPROVALCONFIGURATIONDETAIL*/
	},
	computed: {
		/*APP_DETAIL_COMPUTED_APPROVALCONFIGURATIONDETAIL*/
		computedFilterApprovalConfigurationDetail(){
			return Object.assign({}, this.filterApprovalConfigurationDetail);
		},
		/*END_APP_DETAIL_COMPUTED_APPROVALCONFIGURATIONDETAIL*/
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "approval_configuration").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
